import { createBrowserHistory } from "history";

// eslint-disable-next-line import/prefer-default-export
export const browserHistory = createBrowserHistory({
  basename: "/account-portal"
});
